import { AppShell, Button, Loader } from "@mantine/core";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { TextSearchBox } from "../shared/components/TextSearchBox";
import { initialize, updateField } from "../slices/form/usersTab";
import { RootState } from "../store";
import { useAppDispatch, useAppSelector } from "../hooks";
import { AdminTabHeader } from "../shared/components/TabHeader";
import { useLazyGetUserAttributesQuery } from "../slices/api/usersApi";
import { displayInfoMessage } from "../shared/ErrorMessage";

function UsersTab() {
  const { data } = useAppSelector((state: RootState) => state.usersTab);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data) return; // prevent reset when re-mounting component
    dispatch(
      initialize({
        searchText: "",
      })
    );
  }, []);
  const [_, navigate] = useLocation();
  const [trigger] = useLazyGetUserAttributesQuery();

  const searchText = (data?.searchText ?? "").toLowerCase();

  if (!data) {
    return (
      <AppShell.Main>
        <Loader color="blue" />
      </AppShell.Main>
    );
  }

  return (
    <AppShell.Main>
      <AdminTabHeader label="Users" />
      <TextSearchBox
        textInputProps={{
          placeholder:
            "Enter exact email address, or leave blank to get your user record",
        }}
        setSearchText={(searchText) => {
          dispatch(
            updateField({
              field: "searchText",
              value: searchText,
            })
          );
        }}
        searchText={data!.searchText ?? ""}
      />
      <Button
        mt="md"
        onClick={async () => {
          try {
            const response = await trigger({ email: searchText }).unwrap();
            navigate(`/console/user/userid/${response.userId}`);
          } catch (e) {
            displayInfoMessage("No user was found with that email address.");
          }
        }}
      >
        Get User
      </Button>
    </AppShell.Main>
  );
}

export default UsersTab;
